export default "__VITE_ASSET__Hwc_xSuu__"